/*
 *  Validering av fødselsnummer, organisasjonsnummer, kontonummer og KID
 *
 *  updated 08 Feb 2021
 *  by Lars Erik Storbukås <https://github.com/storbukas>
 *
 *  Source: https://github.com/storbukas/norsk-validator
 *
 *  Licensed under the MIT License
 *  https://opensource.org/licenses/MIT
 *
 */
'use strict';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fodselsnummer_1 = __importDefault(require("./fodselsnummer"));
var kidnummer_1 = __importDefault(require("./kidnummer"));
var kontonummer_1 = __importDefault(require("./kontonummer"));
var organisasjonsnummer_1 = __importDefault(require("./organisasjonsnummer"));
exports.default = {
    kontonummer: kontonummer_1.default,
    kidnummer: kidnummer_1.default,
    fodselsnummer: fodselsnummer_1.default,
    organisasjonsnummer: organisasjonsnummer_1.default,
};
